import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {map, switchMap, tap} from "rxjs/operators";
import {Observable} from "rxjs";
import {SchoolV3RestService} from "../../services/rest/v3/school-rest.service";
import {V3School} from "../../model/v3/schools";

@Component({
    selector: 'app-manager-dashboard',
    templateUrl: './manager-dashboard.component.html',
    styleUrls: ['./manager-dashboard.component.css'],
    standalone: false
})
export class ManagerDashboardComponent implements OnInit {
  schoolId: number;
  school: V3School;

  constructor(
    private activeRoute: ActivatedRoute,
    private router: Router,
    private schoolV3Rest: SchoolV3RestService,
    private route: ActivatedRoute
    ) { }

  ngOnInit() {
    this.activeRoute.parent.paramMap
      .pipe(
        map(params => Number(params.get('schoolId'))),
        tap<number>(schoolId => this.schoolId = schoolId),
        switchMap( schoolId => this.loadSchool(schoolId)),
        tap(school => this.school = school)
      )
      .subscribe( );
  }

  private loadSchool(schoolId: number): Observable<V3School> {
    return this.schoolV3Rest.getSchool(schoolId)
  }

  getSchoolName() {
    if (!this.school) return null;
    return this.school.details.name;
  }


  redirectTo(path: string) {
    this.router.navigate(['../', ...path.split("/")], {relativeTo: this.route}).then()
  }
}
